import React from "react";
import { storyblokEditable, renderRichText } from "gatsby-source-storyblok"

const AboutSection = ({ blok }) => {

  return(
    <section className="my-16">
      <div {...storyblokEditable(blok)} key={blok._uid} className="flex flex-wrap md:flex-nowrap items-stretch">

        <div className="hidden md:block md:w-1/2">
          <img className="w-full h-full object-cover" loading="lazy" src={`${blok.leftImage.filename}/m/0x800`} alt={blok.leftImage.alt}/>
        </div>

        <div className="w-full md:w-1/2 max-w-3xl p-0 md:p-10 relative">
          <div className="p-4 md:p-0">
            <h3 className="text-2xl font-bold my-3 flex items-center">
              <img className="w-[44px] h-[56px] mr-3" src="/icons/about-amnet-title-star.svg" alt="Star icon"/>
              {blok.title}
            </h3>
            <h4 className="text-lg font-bold font-serif mb-8">{blok.subTitle}</h4>
            <div className="my-4" dangerouslySetInnerHTML={{__html: renderRichText(blok.description)}} />
          </div>
          <img className="block md:hidden w-full h-auto object-cover" loading="lazy" src={`${blok.leftImage.filename}/m/`} alt={blok.leftImage.alt}/>

          <img className="w-[300px] h-[112px] z-10 absolute md:left-[-250px] md:bottom-[100px] rotate-90 md:rotate-0" src="/icons/yellow-arrow-left.svg" alt="Yellow arrow"/>

          <div className="flex flex-wrap my-14 mx-4">
            <div className="w-full 2xl:w-1/2 my-8 md:my-4 font-serif" dangerouslySetInnerHTML={{__html: renderRichText(blok.trivia)}} />
            <div className="w-full 2xl:w-1/2 mt-8 flex relative">
              <img className="origin-top rotate-[-10deg] w-[210px] he-auto rounded-md z-10" loading="lazy" src={`${blok.triviaLowerImage.filename}/m/`} alt={blok.triviaLowerImage.alt}/>
              <img className="origin-top rotate-[10deg] w-[210px] h-auto rounded-md absolute top-[-20px] left-[140px]" loading="lazy" src={blok.triviaUpperImage.filename} alt={blok.triviaUpperImage.alt}/>
            </div>
          </div>
          <img loading="lazy" src="/img/amny-kun2.png" className="w-[130px] h-auto absolute right-0 bottom-0 pr-3" alt="Amnet Kun"/>
        </div>
      </div>
    </section>
  ) 
}

export default AboutSection
